import React, { Component } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button
} from 'reactstrap';
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} from "react-simple-maps";
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

class Map extends Component {
  constructor(props) {
    super(props);

    this.handleGeoClick.bind(this);
  }

  handleGeoClick(geoObj, province) {
    const { business } = this.props;

    fetch('/api/prefectures?filter[name]=' + encodeURIComponent(geoObj.name)).then((resp) => resp.json())
      .then((respJson) => {
        respJson.data.forEach((item) => {
          fetch(item.relationships.province.links.related).then((resp) => resp.json())
            .then((respJson) => {
              if(respJson.data.attributes.name === province) {
                window.location.href = "/discover_unifying_factors/business/" + business + 
                  "/prefecture/" + item.id;
              }
            });
        });
      });
  }

  getColor(province, geoName) {
    const { businessCounts } = this.props;
    let count = 0, color = "#ECEFF1"; 

    businessCounts.forEach((prefecture) => {
      if(prefecture.name === geoName && prefecture.province === province) {
        count = prefecture.value; 
      } 
    });

    if(count >= 1 && count <= 5) {
      color = "#29A645";
    } else if(count >= 6 && count <= 10) {
      color = "#FFC107";
    } else if(count > 10) {
      color = "#DC3545"; 
    }

    return color;
  }

  render() {
    const { prefectureGeo, business, businessTotal, businessCounts } = this.props;

    return (
      <Card className="mb-3">
        <CardHeader className="bg-primary text-white">
          There are {businessTotal} locations of {business} in China.
        </CardHeader>
        <CardBody className="p-0">
          { businessCounts ?
            <div className="w-100 my-0 mx-auto">
              <ComposableMap
                projectionConfig={{
                  scale: 1000,
                  rotation: [-11,0,0],
                }}
                width={980}
                height={650}
                style={{
                  width: "100%",
                  height: "auto",
                }}
                >
                <ZoomableGroup center={[105,37]} disablePanning>
                  <Geographies geography={"/geographies/ChinaAllPrefectures.json"} disableOptimization>
                    {(geographies, projection) => geographies.map((geography, i) => {
                      if(geography.id !== "ATA") {
                        let defaultFill = "#ECEFF1";

                        if(geography.properties.notAvailable) {
                          return (
                            <Geography
                              key={i}
                              id={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}
                              geography={geography}
                              projection={projection}
                              style={{
                                default: {
                                  fill: defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  opacity: 0.3,
                                  outline: "none",
                                },
                                hover: {
                                  fill: defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  opacity: 0.3,
                                  outline: "none",
                                },
                                pressed: {
                                  fill: defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  opacity: 0.3,
                                  outline: "none",
                                },
                              }}
                            >
                              <UncontrolledTooltip placement="bottom" delay={0} target={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}>
                                {geography.properties.name} (Coming Soon)
                              </UncontrolledTooltip>
                            </Geography>
                          );
                        } else {
                          return (
                            <Geography
                              key={i}
                              id={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}
                              geography={geography}
                              projection={projection}
                              onClick={(geo) => this.handleGeoClick(geo.properties, geo.properties.province)}
                              style={{
                                default: {
                                  fill: businessCounts ? this.getColor(geography.properties.province, geography.properties.name) : defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  outline: "none",
                                },
                                hover: {
                                  fill: "#215796",
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  outline: "none",
                                },
                                pressed: {
                                  fill: "#e25241",
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  outline: "none",
                                },
                              }}
                            >
                              <UncontrolledTooltip placement="bottom" delay={0} target={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}>
                                {geography.properties.name}
                              </UncontrolledTooltip>
                            </Geography>
                          );
                        }
                      }
                    })}
                  </Geographies>
                </ZoomableGroup>
              </ComposableMap>
            </div>
            :
            <div className="w-100 mt-5 mx-auto text-center">
              <FontAwesomeIcon icon={faSpinner} size="6x" spin className="text-center text-primary" />
            </div> }
        </CardBody>
        <CardFooter>
          <h5>
            <span className="badge badge-pill badge-success mr-2">1-5 Locations</span>
            <span className="badge badge-pill badge-warning mr-2 text-white">6-10 Locations</span>
            <span className="badge badge-pill badge-danger">10+ Locations</span>
          </h5>
        </CardFooter>
      </Card>
    ); 
  }
}

export default Map;
